var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#282829"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.4822 22 22 17.4741 22 12.0052C22 6.52593 17.4717 2 12 2C6.51782 2 2 6.52593 2 12.0052C2 17.4741 6.5283 22 12 22ZM9.71488 17.0131C9.44235 16.7407 9.44235 16.3112 9.7044 16.0597L13.9706 12.0052L9.7044 7.96124C9.44235 7.7098 9.44235 7.26977 9.71488 7.01833C9.97694 6.76689 10.3753 6.78785 10.6583 7.04976L14.9769 11.1461C15.4801 11.6176 15.4801 12.4138 14.9769 12.8748L10.6583 16.9817C10.4067 17.2226 9.94549 17.2331 9.71488 17.0131Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightMore);
export default __webpack_public_path__ + "static/media/rightMore.b59e1ed782e31746466ffc090486871a.svg";
export { ForwardRef as ReactComponent };